/**
 * Admin Analytics — Sovereign Emerald family, Admin voice.
 * Same cream paper, racing-green ink and type roles as the Manager
 * dashboard; the accent shifts from champagne to PETROL ink so the two
 * surfaces are never confused. Petrol is the only new token pair.
 */
export const ADMIN = {
  /** The Admin accent — deep petrol ink (AA on cream at any weight). */
  petrol: '#14606B',
  petrolDeep: '#0E4A52',
  petrolTint: 'rgba(20,96,107,0.12)',
} as const;

/** Usage-trend vocabulary colours (one chip style everywhere). */
export const USAGE_COLOR = {
  growing: { ink: '#1F5A47', fill: '#339274' },
  steady: { ink: '#5A6275', fill: '#5A6275' },
  declining: { ink: '#8A5A08', fill: '#C9A961' },
  dormant: { ink: '#9F1239', fill: '#9F1239' },
} as const;

/** Admin section eyebrow — petrol instead of the Manager's green. */
export const ADMIN_EYEBROW_CLASS =
  'text-[10px] font-bold uppercase tracking-[0.18em] text-[#14606B]';
